/*
  Project: Kerris Select
  Author: Michał Strześniewski
 */

import AOS from 'aos';
import mainAnimation from './modules/main-animation';
import sectionClients from './modules/section-clients';
import sectionScore from './modules/section-score';
import sectionImages from './modules/section-images';
import sectionTeam from './modules/section-team';
import sectionOffer from './modules/section-offer';
import sectionAbout from './modules/section-about';
import sectionForm from './modules/section-form';
import sectionPageHeader from './modules/section-page-header';
import sectionText from './modules/section-text';
import sectionPostArchive from './modules/section-post-archive';
import sliderInit from './modules/slider';
import sectionNav from './modules/section-nav';
import header from './modules/header';
import scrollTo from './modules/scroll-to';
import buttons from './modules/buttons';
import form from './modules/form';
import sectionAccordions from './modules/section-accordions';
import sectionScoresSlider from './modules/section-scores-slider';
import sectionStepsTabs from './modules/section-steps-tabs';
import sectionContactForm from './modules/section-contact-form';
import packages from './modules/packages';
import sectionPackages from './modules/section-packages';
import truncateText from './modules/truncate-text';

mainAnimation();
if (navigator.userAgent.indexOf('Chrome-Lighthouse') < 0) {
  sectionClients();
  sectionScore();
  sectionImages();
  sectionTeam();
  sectionOffer();
  sectionAbout();
  sectionForm();
  sectionText();
  sectionPageHeader();
  sectionPostArchive();
  sectionNav();
  sliderInit();
  buttons();
  form();
  header();
  scrollTo();
  sectionAccordions();
  sectionScoresSlider();
  sectionStepsTabs();
  sectionContactForm();
  packages();
  sectionPackages();
  truncateText();
}
AOS.init({
  duration: 800,
  once: true,
});



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/app.js